import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, TemplateRef } from '@angular/core';
import {
  FieldType,
  FieldTypeConfig,
  FormlyFieldConfig,
} from '@ngx-formly/core';
import { Observable } from 'rxjs';
import { FormlyFieldProps } from '../../..';

interface CustomFieldProps extends FormlyFieldProps {
  customTemplate?: Observable<TemplateRef<any> | undefined>;
}

export interface FormlyCustomTemplateFieldConfig
  extends FormlyFieldConfig<CustomFieldProps> {}

@Component({
  selector: 'kon-custom-template-type',
  imports: [CommonModule],
  template: `
    <ng-container
      *ngTemplateOutlet="
        (props.customTemplate | async) || null;
        context: { $implicit: model, field: this, value: formControl.value }
      "
    ></ng-container>
  `,
  styles: ``,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CustomTemplateTypeComponent extends FieldType<
  FieldTypeConfig<CustomFieldProps>
> {}
